import createTxpConfiguration from './createTxpConfiguration';
import { populateCalendarPeekImages } from '../../utils/view/populateImages';
import getTxpLocation from '../../utils/view/getTxpLocation';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { createCalendarPeekStyle } from 'owa-txp/lib/utils/view/createTxpStyle';
import TxpDatapoint from 'txp-data/lib/schema/configSchema/TxpDatapoint';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import { getPackageBaseUrl } from 'owa-config';
import CardRole from 'txp-data/lib/schema/innerSchema/CardRole';

export default function createCalendarPeekTxpConfiguration(
    isInvoiceSupported: boolean,
    entityNamesMap: number,
    txpLocation: EnhancedLocation,
    colorScheme: ColorScheme,
    styles: any,
    isServiceReservationSupported: boolean,
    datapointLogger?: (
        txpDatapoint: TxpDatapoint,
        datapointName: string,
        internetMessageId?: string
    ) => void,
    onViewInMailClicked?: () => void
): TxpConfiguration {
    let txpConfig = createTxpConfiguration(
        isInvoiceSupported,
        entityNamesMap,
        true, // showActionButtons is true for calendar peek,
        isServiceReservationSupported,
        CardRole.Primary,
        false, // isEditableCardEnabled is false for calendar
        datapointLogger,
        onViewInMailClicked
    );

    const txpImages = populateCalendarPeekImages(colorScheme);
    txpConfig.txpImages = txpImages;
    txpConfig.txpImages.packageBaseUrl = getPackageBaseUrl;
    txpConfig.getLocationControl = (showFullAddress: boolean, telephone?: string) =>
        getTxpLocation(
            txpLocation,
            showFullAddress,
            txpImages,
            createCalendarPeekStyle(colorScheme, styles),
            telephone
        );

    return txpConfig;
}
